import axios from 'axios';
import authHeader from '../auth-header';
import { API_URL } from '../API_URL';

class EventService{

    GetStudentData(StudentID){
        return axios.get(API_URL + `AR_StudentInfo/GetStudentData?StudentID=${StudentID}`,
            { headers: authHeader() } )            
      }
      //this.form.name , this.form.nationalID  , 10 , this.form.phoneNumber , this.form.email  , this.form.addresss  , this.form.birthDate  , this.form.FacultiesInterestedIN , this.form.hearAboutUs, this.form.highSchoolCertificate , this.form.currentSchool , this.form.questionText , this.form.serial
                         // ?name=htyutyuty&nationalID=12345645691254225&userID=10&phoneNumber=1470000058963214&email=eng.hala%40b2hbh.com&addresss=fghghh&birthDate=02%2F02%2F1989&hearAboutUs=1&highSchoolCertificate=1&currentSchool=hgjgh&questionText=hhj&serial=2&FacultiesInterestedIN=1&FacultiesInterestedIN=2
       OnlineBasicDataInsert(name , nationalID , userID, phoneNumber, email , addresss , birthDate , hearAboutUs , highSchoolCertificate, currentSchool , questionText,serial,FacultiesInterestedIN){
        
        return axios.post(API_URL + `InquiryOnline/OnlineBasicDataInsert?name=${name}&nationalID=${nationalID}&userID=${userID}&phoneNumber=${phoneNumber}&email=${email}&addresss=${addresss}&birthDate=${birthDate}&addresss=${addresss}&hearAboutUs=${hearAboutUs}&highSchoolCertificate=${highSchoolCertificate}&currentSchool=${currentSchool}&questionText=${questionText}&serial=${serial}&FacultiesInterestedIN=${FacultiesInterestedIN}`,{
  
        },
        { headers: authHeader() } )
      }

      SelectAllCertificationGroups(){
        return axios.get(API_URL + `Admission/Admission_SelectAllCertificationGroups`,
            { headers: authHeader() } )            
      }

      Admission_SelectAllCertificationTypeByGroup(serial){
        return axios.get(API_URL + `Admission/Admission_SelectAllCertificationTypeByGroup?serial=${serial}`,
            { headers: authHeader() } )            
      }
      SelectAllCampus(){
        return axios.get(API_URL + `Admission/Admission_SelectAllCampus`,
            { headers: authHeader() } )            
      }
      GetAllHearAboutUs(){
        return axios.get(API_URL + `LookUpInquiry/GetAllHearAboutUs`,
            { headers: authHeader() } )            
      }

      FacultyActiveByBranchAPI(BranchId){
        return axios.get(API_URL + `Lookup/FacultyActiveByBranchAPI?BranchId=${BranchId}`,
            { headers: authHeader() } )            
      }


      GetAllRequestTypeBYCaller(TypeCallerId){
        return axios.get(API_URL + `LookUpInquiry/GetAllRequestTypeBYCaller?TypeCallerId=${TypeCallerId}`,
            { headers: authHeader() } )            
      }


      SelectBasicData(email, nationalid){
        return axios.get(API_URL + `MarketingEventBDSearch/SelectBasicData?email=${email}&nationalid=${nationalid}`,
            { headers: authHeader() } )            
      }


      IREQ_Request_Select(Serial){
        return axios.get(API_URL + `IREQ_RA_Request/IREQ_Request_Select?Serial=${Serial}`,
            { headers: authHeader() } )            
      }
      GetAllComments(requestID){
        return axios.get(API_URL + `Comment/GetAllComments?requestID=${requestID}`,
        { headers: authHeader() } )  
      }
      SelectMarketingEvent(serial){
        return axios.get(API_URL + `MarketingEvent/SelectMarketingEvent?serial=${serial}`,
            { headers: authHeader() } )            
      }
// MarketingEvent/EV_MarketingEvent_SelectAll
SelectMarketing_AllEvents(){
    return axios.get(API_URL + `MarketingEvent/EV_MarketingEvent_SelectAll`,
        { headers: authHeader() } )            
  }



    BasicData_Insert(Name, SystemMethodID, NationalID, EventID, UserID ,  PhoneNumber , Email , Addresss , BirthDate , HighSchoolCertificateID , CurrentSchool, InterestedFlag){
        return axios.post(API_URL + `IEDB_EventBasicDataController/IEBD_BasicData_Insert?Name=${Name}&SystemMethodID=${SystemMethodID}&NationalID=${NationalID}&EventID=${EventID}&UserID=${UserID}&PhoneNumber=${PhoneNumber}&Email=${Email}&Addresss=${Addresss}&BirthDate=${BirthDate}&HighSchoolCertificateID=${HighSchoolCertificateID}&CurrentSchool=${CurrentSchool}&InterestedFlag=${InterestedFlag}`,
           
        { headers: authHeader() } )          
      }




      GetAll_Impressions(){
        return axios.get(API_URL + `LookUpInquiry/GetAllImpressions`,
            { headers: authHeader() } )            
      }



      // GET /api/IED_EventDiscount/IED_LookupDiscounts_SelectALL
      IED_LookupDiscounts_SelectALL(){
        return axios.get(API_URL + `IED_EventDiscount/IED_LookupDiscounts_SelectALL`,
            { headers: authHeader() } )            
      }

      AddDiscountToInquiry(DiscountID, BasicDataID, UserID){
        return axios.post(API_URL + `IED_EventDiscount/IED_AddDiscountToInquiry?DiscountID=${DiscountID}&BasicDataID=${BasicDataID}&UserID=${UserID}`,
            { headers: authHeader() } )            
      }




      BD_Faculties_Insert(BasicDataID	, FacultyID, UserID){
        return axios.post(API_URL + `ContactDetails_Faculties/BD_Faculties_Insert?BasicDataID=${BasicDataID}&FacultyID=${FacultyID}&UserID=${UserID}`,
            { headers: authHeader() } )            
      }

}



export default new EventService();